/**
 * URL contract for sponsor-scoped Assessment Details navigation.
 *
 * Every sponsor request on a shared assessment (originator, accepted joiner, pending
 * joiner) shares the SAME `vqa_request_id` — the union query keys all per-sponsor rows
 * off one assessment. `?sponsor={name}&status={accepted|pending}` is how the Details
 * page (which shares that same route) tells WHICH sponsor's instance to render.
 *
 * The originator has no status of its own on this contract (it's the baseline, not a
 * join) — build with `status: null` to get the base URL back, unchanged.
 */

/** Maps the grid's Request Type badge value to the URL's `status` query value. */
const REQUEST_TYPE_TO_STATUS_PARAM = {
  "Joined Request": "accepted",
  "Request Pending": "pending",
};

export function requestTypeToStatusParam(requestType) {
  return REQUEST_TYPE_TO_STATUS_PARAM[requestType] ?? null;
}

/**
 * @param {string} basePath - e.g. `/Backend/Assessment/{vqa_request_id}/Manage`
 * @param {string|null|undefined} sponsorName
 * @param {"accepted"|"pending"|null|undefined} status
 * @returns {string} basePath unchanged when sponsorName or status is missing (originator).
 */
export function buildSponsorScopedDetailsUrl(basePath, sponsorName, status) {
  if (!basePath) return basePath;
  if (!sponsorName || !status) return basePath;
  const params = new URLSearchParams({ sponsor: sponsorName, status });
  return `${basePath}?${params.toString()}`;
}
